module.exports = __webpack_public_path__ + "media/images/blogs-2da37e95ff5454fa8f09dd324d20aa48.png";